/* eslint-disable @next/next/no-img-element */
import { Box, Stack, Typography } from "@mui/material";

const clampStyles = (n) => ({
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    textOverflow: "ellipsis",
    WebkitLineClamp: n,
    lineClamp: n,
});

// find a space near the middle and split into two lines
const splitToTwoLines = (text) => {
    if (!text) return text;
    if (text.includes("\n")) return text; // caller gave an explicit break
    const mid = Math.floor(text.length / 2);
    let idx = text.lastIndexOf(" ", mid);
    if (idx === -1) idx = text.indexOf(" ", mid);
    if (idx === -1) return text; // single word; nothing to split
    return text.slice(0, idx) + "\n" + text.slice(idx + 1);
};

export default function Heading({
    title,
    subtitle,
    lineClamp = 1, // 1 by default
    showSparkle,
    underlineSrc = "/img/app/Underline.svg",
    mb = 8,
    forceTwoLines = true, // when lineClamp=2, insert a break automatically
    titleColor = "#111",
    subtitleColor = "text.secondary",
}) {
    const clamp = clampStyles(lineClamp);
    const displayTitle =
        lineClamp === 2 && forceTwoLines ? splitToTwoLines(title || "") : title;

    return (
        <Stack alignItems="center" spacing={1.5} sx={{ mb: { xs: 4, md: mb ? mb : 8 } }}>
            {subtitle && (
                <Typography
                    className="jura"
                    sx={{
                        fontSize: 20,
                        color: subtitleColor,
                        letterSpacing: ".03em",
                    }}
                >
                    {subtitle}
                </Typography>
            )}

            {title && (
                <Box sx={{ textAlign: "center", position: "relative" }}>
                    <Typography
                        component="h2"
                        className="jura"
                        sx={{
                            fontWeight: 700,
                            fontSize: { xs: 28, md: 42 },
                            lineHeight: 1.2,
                            color: titleColor,
                            textAlign: "center",
                            whiteSpace: lineClamp === 2 ? "pre-line" : "normal", // honor \n
                            ...clamp,
                        }}
                    >
                        {displayTitle}
                    </Typography>
                    {
                        showSparkle && <Box
                            component="img"
                            src={showSparkle}
                            alt=""
                            aria-hidden="true"
                            sx={{
                                mt: { xs: 1, md: 1.5 },
                                mx: "auto",
                                width: { xs: 50, md: 60 },
                                height: "auto",
                                display: "block",
                                pointerEvents: "none",
                                userSelect: "none",
                                position: "absolute",
                                top: -35,
                                right: -40
                            }}
                        />
                    }

                    <Box
                        component="img"
                        src={underlineSrc}
                        alt=""
                        aria-hidden="true"
                        sx={{
                            position: "absolute",
                            right: 0,                      // <- end of the div
                            bottom: { xs: -25, md: -30 },  // move slightly below text
                            width: { xs: 140, md: 200 },
                            height: "auto",
                            display: "block",
                            pointerEvents: "none",
                            userSelect: "none",
                        }}
                    />
                </Box>
            )
            }
        </Stack >
    );
}
